import { tokenAuthApiInstance } from 'utils/auth';
import { Logger } from 'utils/logger';

import { PROXY_ACCESS_CONFIG } from './constants';

export type ProxyAccessConfigType = {
  criteriaToShowMenu: Array<BaseOnAgeItems>;
  proxyDefinitionText: Array<LanguageTextItems>;
};

export type BaseOnAgeItems = {
  basedOnAge: boolean;
  age: number;
  secondAge?: number | undefined;
  operand: string;
};

export type LanguageTextItems = {
  language?: string;
  locale: string;
  text: string;
};

export type ProxyAccessConfigResponse = ProxyAccessConfigType;

export const getProxyAccessConfig = async (): Promise<ProxyAccessConfigResponse> => {
  try {
    const response = await tokenAuthApiInstance.authAxios().get(PROXY_ACCESS_CONFIG);
    const { proxyAccessItems } = response.data;
    return proxyAccessItems;
  } catch (error) {
    Logger.error(error);
    throw error;
  }
};
